// @ts-nocheck
(function ($) {
  $(window).on("load resize", function () {
    // $(".redesign-21 .col-three-grid .wrapper .item .text-wrap h6").matchHeight();
    // $(".redesign-21 .col-three-grid .wrapper .item .img-wrap").matchHeight();
    $(".redesign-21 .col-three-grid .wrapper .item .img-wrap").css(
      "overflow",
      "hidden"
    );
    var height = $(
      ".redesign-21 .banner-fourth-level .list-wrap"
    ).outerHeight();
    var windowWidth = $(window).width();
    if (windowWidth > 768) {
      $(".redesign-21 .banner-fourth-level .item").css(
        "height",
        height
      );
    } 
    // else {
    //   $(".redesign-21 .banner-fourth-level .item").css(
    //     "height",
    //     "auto"
    //   );
    // }
  });
  $(document).ready(function () {
    var body = "body";
    if (
      $(body).hasClass("slug-dell-tech-world-2020") ||
      $(body).hasClass(
        "slug-5-scenarios-that-demand-hybrid-cloud-deployment"
      ) ||
      $(body).hasClass(
        "slug-the-best-of-both-worlds-storage-area-networks-and-the-hybrid-cloud"
      )
    ) {
      $(".col-three-grid").removeClass("no-padding-top");
    }
    if (
      $(body).hasClass("slug-integrated-media-kit") ||
      $(body).hasClass("slug-media-kit")
    ) {
      $(".banner-fourth-level").removeClass("padding-bottom-10");
    }

    // ------filter---------
    $(".filter-container .filter > span").on("click", function (e) {
      e.stopPropagation();
      if ($(this).parent().hasClass("active")) {
        $(this).parent().removeClass("active");
        $(this).siblings().slideUp();
      } else {
        $(this).parent().addClass("active");
        $(this).siblings().slideDown();
        $(this).parents(".filter").siblings().removeClass("active");
        $(this)
          .parents(".filter")
          .siblings()
          .find(".filter-dropdown")
          .slideUp();
      }
    });
    $(".filter-container .filter ul li span").on("click", function (e) {
      e.stopPropagation();
      if (!$(this).hasClass("active")) {
        var text = $(this).text();
        $(this).parents(".filter").children("span").text(text);
        $(this).addClass("active");
        $(this).parent().siblings().children("span").removeClass("active");
      }
      $(this).parents(".filter-dropdown").slideUp();
      $(this).parents(".filter").removeClass("active");
    });
    $(document).on("click", function () {
      $(".filter-container .filter").removeClass("active");
      $(".filter-container .filter .filter-dropdown").slideUp();
    });
    // $(
    //   ".redesign-21 .banner-fourth-level .wrapper .row-wrap .single-col"
    // ).matchHeight();

    // var height = $(
    //   ".redesign-21 .banner-fourth-level .wrapper .row-wrap .list-block .list-wrap"
    // ).outerHeight();
    // var windowWidth = $(window).width();
    // if (windowWidth > 768) {
    //   $(".redesign-21 .banner-fourth-level .wrapper .item").css(
    //     "height",
    //     height
    //   );
    // } else {
    //   $(".redesign-21 .banner-fourth-level .wrapper .item").css(
    //     "height",
    //     "auto"
    //   );
    // }
  });

  $(window).on("load resize", function () {
    var windowWidth = $(window).width();
    var itemHeight = $(
      ".redesign-21 .banner-fourth-level .wrapper .item.featured-card"
    ).outerHeight();
    var $listWrap = $(
      ".redesign-21 .banner-fourth-level .wrapper .row-wrap .list-block .list-wrap"
    );

    if (windowWidth < 1234 && windowWidth > 767) {
      $listWrap.css("height", itemHeight + "px");
    } else {
      $listWrap.css("height", "auto");
    }

    // $('.redesign-21 .col-three-grid').css('opacity', '1');

    setTimeout(function () {
      $(".redesign-21 .col-three-grid .wrapper .item .text-wrap h6").dotdotdot({
        height: 48,
      });

      $(
        ".redesign-21 .col-three-grid .wrapper .item .text-wrap .hovered-content span, .redesign-21 .col-three-grid .wrapper .item .text-wrap .hovered-content p"
      ).dotdotdot({
        height: 48,
      });
    }, 3000);
  });
})(jQuery);
